


















































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { passwordApi } from "@/plugins/auth-plugin/services/password.api";

@Component({})
export default class Users extends Vue {
  dialog = false;
  dialogPwd = false;

  isNew = true;

  editedIndex = -1;

  defaultItem = {
    id: "",
    userName: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailAddress: "",
    active: true,
    type: 0,
    typeS: "0",
    password: "",
    password2: "",
  };

  show1 = false;
  rules = {
          required: value => !!value || "Szükséges.",
          min: v => v.length >= 4 || "Legalább 4 Betű",
          matching: v => /^(?=.*\d)[a-zA-Z\d\W]{4,}$/.test(v) || "A jelszónak legalább 4 karakterből kell állnia, és tartalmaznia kell legalább 1 számot, tartalmazhat még betűt és szimbólumot.",

          passwordMatch: () => this.editedItem.password === this.editedItem.password2
                                || "A jelszavak nem egyeznek meg.",
        };


  editedItem = Object.assign({}, this.defaultItem);

  dollySearchTerm = "";
  localDollies = [];

  rowsPerPageItems = [5, 10, 25, 50, { text: "All", value: -1 }];

  pagination = {
    sortBy: "UserName",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("users-rowsPerPage") ?
                        parseInt(this.$cookies.get("users-rowsPerPage"), 10) : 10
  };
  totalUserItem = 2;

  @State("users") usersState: any;
  @Action("getUsers") getUsers: any;
  @Action("saveUser") saveUser: any;
  @Action("deleteUser") deleteUser: any;
  @Action("saveNewPassword") saveNewPassword: any;

  @State("dollies") dollyState: any;
  @Action("getDollies") getDollies: any;

  formTitle() {
    return this.editedIndex === -1
      ? this.$t("ADMIN_USERS_NEW")
      : this.$t("ADMIN_USERS_EDIT");
  }

  created() {
    // --
  }

  getHeaders() { return [
      { text: " ", value: "", sortable: false, width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_PASSWORD"), value: "password", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_USER_NAME"), value: "userName", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_NAME"), value: "", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_ACTIVE_INACTIVE"), value: "active", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_ROLE"), value: "type", width: "1%" },
    ];
  }

  passwordMatch() {
    return this.editedItem.password === this.editedItem.password2
                                || "A jelszavak nem egyeznek meg.";
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("users-rowsPerPage", pagination.rowsPerPage);

    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage
    };
    this.getUsers(page);
  }

  editItem(item) {
    this.isNew = false;
    this.editedIndex = this.usersState.users.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.editedItem.typeS = this.editedItem.type.toString();

    this.dialog = true;
  }

  deleteItem(item) {
    const index = this.usersState.users.indexOf(item);

    if (confirm("Do you really want to delete the User?")) {
      this.deleteUser({ id: item.id, index });
    }
  }

  close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.isNew = true;
  }

  save() {

    if (this.editedItem.id === "" && this.editedItem.userName === "") {
      this.usersState.userSnacktext = "A felhasználónév kötelező.";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    if (  this.editedItem.lastName === "" || this.editedItem.firstName === "") {
      this.usersState.userSnacktext = "A vezeték és utónév kötelező";
      this.usersState.userSnackbar = true;
      // we need to have last name
      return;
    }


    this.editedItem.type = parseInt(this.editedItem.typeS, 10);
    this.saveUser({
      data: JSON.stringify(this.editedItem),
      index: this.editedIndex
    }).then(res => {
      this.close();
    }).catch(err => {
      // ---
    });
  }

  sendPasswordReset(item ) {

    console.log(item);

    this.editedItem = item;
    this.editedItem.password = "";
    this.editedItem.password2 = "";

    this.dialogPwd = true;
  }

  closePwd() {
    this.dialogPwd = false;
  }

  savePwd() {

    if (this.editedItem.id === "") {
      this.usersState.userSnacktext = "Nincs felhasználó kiválasztva";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    if (this.editedItem.password !== this.editedItem.password2 || this.editedItem.userName === "" ) {
      this.usersState.userSnacktext = "A jelszavakat meg kell adni és egyezniük kell";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    this.saveNewPassword({
      userId: this.editedItem.id,
      password: this.editedItem.password
    }).then(res => {
      this.closePwd();
    }).catch(err => {
      // ---
    });
  }
}
